module.exports = __webpack_public_path__ + "static/gen3-65c031c2618b00bb6d0b161b29cc2774.svg";